/* eslint-disable no-restricted-imports */
import { createContext } from 'react';
// eslint-disable-next-line
import { VueFormatterFeatureServiceInterfaceV1 } from '@oneaudi/vue-formatter-service/lib/cjs/v1/vue-formatter-feature-service';
import type { GfaLocaleServiceV1 } from '@volkswagen-onehub/gfa-locale-service';
import type { AudiFootnoteRefernceServiceScopeManagerInterfaceV3 } from '@oneaudi/footnote-reference-service';
import type { EditorJsonContent } from './ContentInterfaces';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import type { Logger } from '@feature-hub/core';

export type AppServices = {
  featureAppId: string;
  content?: EditorJsonContent;
  trackingService?: TrackingServiceV2;
  loggerService?: Logger;
  localeService: GfaLocaleServiceV1;
  vueFormatterService: VueFormatterFeatureServiceInterfaceV1;
  footnoteReferenceService: AudiFootnoteRefernceServiceScopeManagerInterfaceV3;
};

export const ContentContext = createContext<AppServices | null>({
  featureAppId: '',
  loggerService: console,
  localeService: {} as GfaLocaleServiceV1,
  vueFormatterService: {} as VueFormatterFeatureServiceInterfaceV1,
  footnoteReferenceService: {} as AudiFootnoteRefernceServiceScopeManagerInterfaceV3,
});
